import { combineReducers } from 'redux';
import apps from './apps/reducer';

const reducer = combineReducers({
  apps,
});

export default reducer;
